export const Text = (function () {
	'use strict';

	function init() {
		// for the continue_reading shortcode
		$(".show_content").click(function () {
			var hideShowContent = $(this).siblings(".hide_show_content");
			var overlay = hideShowContent.find(".overlay");

			hideShowContent.toggleClass("expanded");

			if (hideShowContent.hasClass("expanded")) {
				hideShowContent.animate({ height: hideShowContent[0].scrollHeight }, 400, function () {
					overlay.hide();
				});
				$(this).hide();
			} else {
				overlay.show();
				hideShowContent.animate({ height: "100px" }, 400);
			}
		});
	}

	return {
		init: init,
	};
})();
